import { Flat } from "./flat.js";

export class CleanHouse extends Flat {
    static info = {
        key: "clean-house",
        name: "Clean the house",
        description: "Let's prepare for the New Year by cleaning the house. Find the broom and then search for dirty spots. Clean five spots and you'll be able to advance to the next level of the celebration! Use arrow keys to navigate and the spacebar to pick up the broom and clean the spots.",
        logo: { x: 200, y: 520 },
        won: false
    }
    constructor(key, level, options) {
        super(key, level, {...options, x: 2200, y: 1100, holder: true});
        this._layout = {
            ...this._layout, splotch: [
                {
                    name: "ch-splotch",
                    positions: [
                        {"left": 110, "top": 1545},
                        {"left": 1460, "top": 1855},
                        {"left": 2090, "top": 655},
                        {"left": 1400, "top": 370},
                        {"left": 2990, "top": 485},
                        {"left": 3360, "top": 2133}
                    ]
                }
            ]
        }
        this._splotches = null
        this._pickables = {
            group: null,
            list: [
                {
                    name: "ch-broom",
                    position: { "left": 2380, "top": 410 },
                    peipei: {
                        take: "Now it’s time to sweep out the old to make room for the new! Let’s go find those spots!"
                    }
                }
            ]
        }
    }
    preload() {
        super.preload()
        this._pickables.list.forEach(d => this.load.image(d.name, `assets/clean-house/${d.name}.png`))
        this.layout.splotch.forEach(i => this.load.image(i.name, `assets/clean-house/${i.name}.png`))
        this.load.audio({ key: 'swoosh', url: [ 'assets/sounds/swoosh.mp3' ] });
    }
    create() {
        super.create()
        this.peiPeiSay("Let's get ready for the New Year! First, go find the broom! Use the spacebar to pick it up")
        this.physics.add.collider(this.bob, this._furniture);
        this._splotches = this.physics.add.staticGroup();
        this.layout.splotch.forEach(a => a.positions.forEach(p => this._splotches.create(p.left, p.top, a.name).setOrigin(0, 0).refreshBody()))
        this._pickables.group = this.physics.add.staticGroup()
        this._pickables.list.forEach(d => this._pickables.group.create(d.position.left, d.position.top, d.name).setOrigin(0, 0).refreshBody().setDepth(60))
        const totalStars = this.layout.splotch[0].positions.length * this._GAME_ACTION_POINT
        this.board.score.setText(`0/${totalStars}`)
    }
    onSpace(){
        const handleBroom = () => {
            const overlaps = this._pickables.group.children.entries.filter(d => this.physics.overlapRect(d.x, d.y, d.width, d.height, true, false).length !== 0)
            if (1 !== overlaps.length) return
            this.sound.play("find-object")
            this._holder.back().take(overlaps[0])
        }
        handleBroom()

        const sweepBroom = () => {
            if (!this._holder.holding()) return
            const splotches = this._splotches.children.entries.filter(d => this.physics.overlapRect(d.x, d.y, d.width, d.height, true, false).length !== 0)
            if (splotches.length !== 1) return
            splotches[0].destroy()
            this.sound.play("swoosh")
            const totalStars = this.layout.splotch[0].positions.length * this._GAME_ACTION_POINT
            this.board.score.setText(`${parseInt(this.board.score.text) + 5}/${totalStars}`)
            const remaining = this._splotches.countActive(true)
            if (remaining > 0) this.say("Nice job! You earned 5 star!")
            if (remaining !== 0) return
            this.peiPeiSay("Mission Accomplished!")
            this.win(this.board.score.text, this._level.current.index + 1)
        }
        sweepBroom()
    }

}